module.exports = "<div class=\"swiper-container\">\n\t<div class=\"swiper-wrapper\">\n\t\t<ng-content></ng-content>\n\t</div>\n\t<div class=\"swiper-pagination\"></div>\n\t<!--<div class=\"swiper-button-prev\"></div>\n\t<div class=\"swiper-button-next\"></div>\n\t<div class=\"swiper-scrollbar\"></div>-->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nikolay/Documents/GitHub/menu-web/src/app/components/swiper/swiper.html
// module id = ../../../../../src/app/components/swiper/swiper.html
// module chunks = main